import React from 'react';

const SectionSeparator = () => (
  <div className="relative h-px w-full bg-gradient-to-r from-transparent via-slate-800 to-transparent my-12" />
);

export default SectionSeparator;
